<template>
  <div class="body d-flex pb-3">
    <div class="container-xxl card">
      <div class="row align-items-center">
        <div class="border-0 mb-4">
          <div
            class="card-header py-3 no-bg bg-transparent d-flex align-items-center px-0 justify-content-between border-bottom flex-wrap"
          >
            <h3 class="fw-bold mb-0">Companies</h3>
            <div class="col-auto d-flex w-sm-100">
              <button
                type="button"
                @click.prevent="toAddUser"
                class="btn btn-primary btn-set-task w-sm-100"
                data-bs-toggle="modal"
                data-bs-target="#expadd"
              >
                <i class="icofont-plus-circle me-2 fs-6"></i>Add
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Row end  -->
      <div class="row mb-3">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div
                id="patient-table_wrapper"
                class="dataTables_wrapper dt-bootstrap5 no-footer"
              >
                <div class="row overflow-auto">
                  <div class="col-sm-12">
                    <table
                      id="patient-table"
                      class="table table-striped align-middle mb-0 nowrap dataTable no-footer dtr-inline"
                      style="width: 100%"
                      role="grid"
                      aria-describedby="patient-table_info"
                    >
                      <thead>
                        <tr role="row">
                          <th>ID</th>
                          <th>Name</th>
                          <th>Email Domain</th>
                          <th>Update</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr v-for="item in items" :key="item.id" class="">
                          <td>{{ item.id }}</td>
                          <td>{{ item.name }}</td>
                          <td>{{ item.emailDomain }}</td>
                          <td>
                            <!-- Update -->
                            <button
                              type="button"
                              class="btn btn-outline-secondary"
                              @click="toUpdateUser(item)"
                            >
                              <i class="icofont-edit text-success"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-secondary"
                              @click="toDeleteTemplate(item)"
                            >
                              <i class="icofont-ui-delete text-danger"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <br />
                <pagination
                  :totalPages="leng"
                  :perPage="request.pageSize"
                  :currentPage="request.currentPage"
                  @pagechanged="onPageChange"
                />
                <modal
                  name="delete"
                  height="auto"
                  styles="background-color: transparent;"
                >
                  <div
                    class="modal-dialog modal-dialog-centered"
                    style="margin: 0 !important; max-width: 600px !important"
                  >
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title fw-bold" id="expeditLabel">
                          Are you sure you want to delete?
                        </h5>
                        <button
                          type="button"
                          class="btn-close"
                          @click="$modal.hide('delete')"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div class="modal-footer">
                        <button
                          type="button"
                          class="btn btn-success"
                          @click="remove"
                          data-bs-dismiss="modal"
                        >
                          Yes
                        </button>
                        <button
                          type="button"
                          class="btn btn-danger"
                          @click="$modal.hide('delete')"
                        >
                          No
                        </button>
                      </div>
                    </div>
                  </div>
                </modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import jwtInterceptor from "../../jwt.interceptor";
import Pagination from "../parts/site/Pagination.vue";
import user from "../../store/user";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "User",
  components: {
    Pagination,
  },
  data: () => ({
    loading: true,
    searchloading: false,
    // exportloading: false,
    request: {
      pageIndex: 1,
      pageSize: 10,
    },
    totalCount: 0,
    leng: 0,
    roles: [
      { name: "Admin", id: "admin" },
      { name: "SuperAdmin", id: "superadmin" },
    ],
    items: [],
  }),
  methods: {
    searchUsers() {
      this.$router.push("/users");
    },
    toAddUser() {
      this.$router.push("/addCompany");
    },
    toUpdateUser(item) {
      user.dispatch("prepareUserUpdate", item);
      this.$router.push("/updateCompany");
    },
    toDeleteTemplate(template) {
      this.rmelm = template.id;
      this.$modal.show("delete");
    },
    remove() {
      jwtInterceptor
        .delete(this.$store.getters.getUrl + "/Companies/" + this.rmelm)
        .then(() => {
          this.refresh();
          this.$toast.success("Deleted", {
            position: "top-right",
          });
          this.$modal.hide("delete");
        })
        .catch((error) => {
          this.$toast.error(error.response.data.title, {
            position: "top-right",
          });
        });
    },
    onPageChange(page) {
      this.request.pageIndex = page;
      this.refresh();
    },
    refresh() {
      jwtInterceptor
        .get(this.$store.getters.getUrl + "/Companies/GetPaged", {
          params: this.request,
        })
        .then((response) => {
          this.items = response.data.data;
          this.totalCount = response.data.totalCount;
          this.leng = response.data.totalPages;
          this.searchloading = false;
        })
        .catch((error) => {
          this.searchloading = false;
          this.$toast.error("System Error!", {
            position: "top-right",
          });
        });
    },
  },
  created() {
    this.refresh();
  },
};
</script>

<style>
[data-theme="high-contrast"] {
  .table-striped > tbody > tr:nth-of-type(odd) > * {
    color: white !important;
  }
}
</style>
